/* unplugin-vue-components disabled */import { render } from "./rcmk.vue?vue&type=template&id=8bc19b0c&scoped=true"
import script from "./rcmk.vue?vue&type=script&lang=js"
export * from "./rcmk.vue?vue&type=script&lang=js"

import "./rcmk.vue?vue&type=style&index=0&id=8bc19b0c&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc19b0c"]])

export default __exports__